module.exports = __webpack_public_path__ + "img/1008.1b253457.jpg";